import Confirm from './index.vue';

const confirmPlugin = {
  install (Vue) {
    // 创建一个子类
    const ConfirmConstructor = Vue.extend(Confirm);
    // 实例化这个子类
    const instance = new ConfirmConstructor();
    // 创建一个div元素，并把实例挂载到div元素上
    instance.$mount(document.createElement('div'));
    // 将el插入到body元素中
    document.body.appendChild(instance.$el);
    // 添加实例方法，可自定义
    Vue.prototype['$confirm'] = (options) => {
      instance.config = { ...instance.config, ...options };
      instance.isShow = true;

      return instance;
    };
  }
};

export default confirmPlugin;



// WEBPACK FOOTER //
// ./src/components/Confirm/index.js